<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EdOUyP/tc-custom/9780061870804.jpg?1726519149606" alt="This image is the cover for the book Memories of John Lennon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memories of John Lennon
      </h1>
      <p class="bookDescription body article font2">
        <p>John Lennon . . . as much a part of our world today as he ever was</p><p>He touched many lives in his brief forty years, and continues to move and inspire millions more to this day. Now, invited by Yoko Ono, friends, family, and fans from all walks of life—including some of the great artists of our day—reminisce about Lennon as a visionary and friend, musician and performer, husband and father, activist and jokester.</p><p>In their own words and drawings, poems and photos, Lennon's life from his childhood through the Beatles years to the happiness and tragedy of his final days become stunningly vivid.</p><p>Intimate glimpses gathered from musicians who knew John, such as Pete Townshend, Sir Elton John, Billy Preston, and Joan Baez; friends and relatives such as producer David Geffen, publicist Elliot Mintz, and cousin Mike Cadwallader; and artists who followed him such as Bono, Alicia Keys, Steve Earle, Jello Biafra, and Carlos Santana.</p><p>And, for the first time, renowned photographer Annie Liebovitz presents every frame of the historic last session with John and Yoko.</p><p>Memories of John Lennon is a rich and deeply felt appreciation of a truly great man.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yoko Ono
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0719e9fa